import React, { useEffect } from 'react';
import { DayWeekPicker } from './DayWeekPicker';
import { Block, Card, Space } from '../../src';
import { addMonths, Locale } from 'date-fns';

export type MonthYear = {
  month: number;
  year: number;
};

export type DayWeekPickerGroupProps = {
  days: Date[];
  setDays: (days: Date[]) => void;
  /**
   * Seznam dnů, které mají být zvýrazněny - např. kvůli informaci že obsahují nějaké záznamy apod.
   */
  highlightedDays?: Date[];
  /*
   * Pokud není vyplněno, je hodnota dnešní.
   */
  monthYear?: MonthYear;
  locale?: Locale;
  pickersCount?: number;
};

export const DayWeekPickerGroup: React.FC<DayWeekPickerGroupProps> = ({
  monthYear,
  locale,
  setDays,
  pickersCount = 2,
  highlightedDays,
  days,
}) => {
  const [showMonthYear, setShowMonthYear] = React.useState<MonthYear>(() => {
    if (monthYear) {
      return monthYear;
    } else {
      return {
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
      };
    }
  });

  useEffect(() => {
    if (monthYear) {
      setShowMonthYear(monthYear);
    }
  }, [monthYear]);

  let tempDate = new Date(showMonthYear.year, showMonthYear.month);
  const showMonthYears: MonthYear[] = [];
  for (let i = 0; i < pickersCount; i++) {
    showMonthYears.push({
      month: tempDate.getMonth(),
      year: tempDate.getFullYear(),
    });
    tempDate = addMonths(tempDate, 1);
  }

  return (
    <Card mode={'view'}>
      <Block>
        <Space vertical size={'3'}>
          {showMonthYears.map((item, index) => (
            <DayWeekPicker
              highlightedDays={highlightedDays}
              locale={locale}
              value={days}
              onChange={setDays}
              monthYear={item}
              showChangeMonth={index === 0}
              onChangeMonthYear={setShowMonthYear}
            />
          ))}
        </Space>
      </Block>
    </Card>
  );
};
